import Modal from "react-bootstrap/Modal";
import { CustomSelect } from "../../../shared/components/CustomSelect";
import styled from "styled-components";
import { useEffect, useState } from "react";
import {
    addOtcMarketPlacePackage,
    addOtcMarketPlace_package_general,
    getAllTokens,
    getApprovers,
} from "../../../utils/services/user.service";
import { Ring } from "@uiball/loaders";
import { toast } from "react-toastify";
import { Button } from "@/shared/components/Button";

const CreateOtcGeneralPackage = ({
    show,
    hide,
    reFetchPackages,
    otcId,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [chain_id, setChain_id] = useState(null);
    const [packageChoice, setPackageChoice] = useState("active");
    const [pool1, setPool1] = useState("");
    const [pool2, setPool2] = useState("");
    const [allTokens, setAllTokens] = useState([]);
    const [allTokensPool2, setAllTokensPool2] = useState([]);
    const [inputId, setInputId] = useState("");
    const [userName, setUserName] = useState("");
    const [searchLoad, setsearchLoad] = useState(false);
    const [searchUserId, setSearchUserId] = useState([]);
    const [dropdownOptions, setDropdownOptions] = useState([]);

    useEffect(() => {
        // Filter and map the allTokens array
        const options = allTokens.map(token => ({
            value: token.symbol,
            label: token.symbol
        }));

        // Update the state with the new dropdown options
        setDropdownOptions(options);

        const Pool2Coins = allTokens
            .filter(token => token.symbol !== 'BTC')  // Filter out the BTC token
            .map(token => ({
                value: token.symbol,
                label: token.symbol
            }));

        // Add the new Fiat Currency option
        Pool2Coins.push({
            value: "fiat_currency",
            label: "Fiat Currency"
        });

        setAllTokensPool2(Pool2Coins);
    }, [allTokens]);

    const [marketplaceInfo, setMarketplaceInfo] = useState({
        packageName: "",
        buyAmount: null,
        token: null,
        transfer_fee: null,
        description: "",
        contract_address: "",
        unlockDay: null,



    });
    const [packageToSell, setPackageToSell] = useState("")
    const { packageName, buyAmount, token, description, unlockDay } =
        marketplaceInfo;
    const initialTokenData = dropdownOptions.map((item) => ({
        symbol: null,
        price: null,
    }));

    const [tokenData, setTokenData] = useState(initialTokenData);
    const newArray = tokenData.filter(
        (item) => item !== null && item !== undefined
    );
    const handleSymbolChange = (idx, event) => {
        const { checked, value } = event.target;
        setTokenData((prevState) => {
            if (checked) {
                const newData = [...prevState];
                newData[idx] = { symbol: value, price: newData[idx]?.price || "" };
                return newData;
            } else {
                const newData = [...prevState];
                newData[idx] = null; // Mark the object as null
                return newData.filter((item) => item !== null); // Filter out null objects
            }
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setMarketplaceInfo((prevInfo) => ({
            ...prevInfo,
            [name]: value,
        }));
    };
    const handlePriceChange = (idx, event) => {
        const { value } = event.target;
        setTokenData((prevState) => {
            const newData = [...prevState];
            newData[idx] = { ...newData[idx], price: value };
            return newData;
        });
    };
    const CreateNewOtcMarketplacePackage = async () => {

        try {
            if (
                !packageName ||
                !buyAmount ||
                !token ||
                !description ||
                !unlockDay ||
                !packageToSell
            ) {
                // Log each field to check its value

            
                toast.error("Please fill in all required fields");
                return;
            }
            

            setIsLoading(true);
            const poolVal = [pool1, pool2].join("-");
            const payload = {
                "market_place_id": otcId,
                "price": buyAmount,
                "token": token,
                "package_name": packageName,
                "package_description": description,
                "unlock_days": unlockDay,
                "package_choice": packageChoice,
                "pool": poolVal,
                want_sell: packageToSell,
                // "owner_id": inputId,
                "swap_pairs": newArray
            }
            const res = await addOtcMarketPlace_package_general(payload);
            toast.success(res.data.Message);
            setIsLoading(false);
            reFetchPackages();
            hide();
        } catch (error) {
            // Handle error
            toast.error(error?.response?.data.Message);
            setIsLoading(false);
        }
    };
    const packageChoiceOptions = [
        { value: "virtual_transfer", label: "Virtual Transfer" },
        { value: "open_contract", label: "Open Contract" },
    ];

    const fetchAllTokens = async () => {
        const payload = {
            chain_id: "",
            limit: 100,
            page_number: 1
        };
        const res = await getAllTokens(payload);
        setAllTokens(res.data.user);
        const filteredData = res.data.data.filter((item) => item.label !== "BTC");
        // console.log("🚀 ~ fetchAllTokens ~ filteredData:---", filteredData)
        // setAllTokensPool2(filteredData);
    };
    useEffect(() => {
        fetchAllTokens();
    }, []);
    const handleInputChange = (name) => {
        setsearchLoad(true);
        if (name.length >= 2) {
            getApprovers({ name })
                .then((res) => {
                    setsearchLoad(false);
                    const arr = res.data.user.map((i) => ({
                        id: i._id,
                        address: i.address,
                        value: i.name,
                        label: i.name,
                        sol_address: i?.sol_address,
                    }));

                    setsearchLoad(false);

                    // Case-insensitive comparison
                    const matchingOptions = arr.filter(
                        (option) => option.value.toLowerCase() === name.toLowerCase()
                    );

                    setSearchUserId(matchingOptions);
                })
                .catch((error) => {
                    setsearchLoad(false);
                    // setstatusCode(400);

                    if (error.message === "Network Error") {
                        // setMsg(`Please Check Your Internet Connection \n Something went Wrong!!${error?.message}`);
                    } else {
                    }
                });
        } else {
            setSearchUserId([]); // Clear options when input length is less than 2
        }

        setsearchLoad(false);
    };
    return (
        <>
            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={show}
                onHide={hide}
            >
                <div
                    className="loader-overlay"
                    style={{
                        display: isLoading ? "flex" : "none",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(255, 255, 255, 0.8)",
                        zIndex: 999,
                    }}
                >
                    <Ring size={65} color="#00897B" />
                </div>
                <Modal.Header closeButton>
                    <Modal.Title className="text-center" style={{ fontSize: "large" }}>
                        <b> Create General OTC Marketplace Package</b>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div
                        className="d-flex flex-column"
                        style={{ boxShadow: "none", fontFamily: "sans-serif" }}
                    >
                        <div className="d-flex flex-row flex-wrap gap-4 ">
                            <div className="col-12 col-md-4">
                                <label>Package Name</label>
                                <InputDiv>
                                    <ChatSearchInput
                                        type="text"
                                        name="packageName"
                                        value={packageName}
                                        className="form-control mt-2"
                                        placeholder="Package Name"
                                        onChange={handleChange}
                                    />
                                </InputDiv>
                            </div>

                            <div className="col-12 col-md-3">
                                <label className="d-flex gap-1">Price of package <span style={{
                                    fontSize: '8px'
                                }}>Token You Get</span></label>


                                <InputDiv>
                                    <ChatSearchInput
                                        type="text"
                                        name="buyAmount"
                                        value={buyAmount}
                                        className="form-control mt-2"
                                        placeholder="Price of package"
                                        onChange={handleChange}
                                    />
                                </InputDiv>
                            </div>
                            <div className=" flex flex-col col-12 col-md-3 ">
                                <label>Package Price Symbol</label>
                                <InputDiv>
                                    <DropdownDiv className="mb-0">
                                        <CustomSelect
                                            // isLoading={searchLoad}
                                            name="receiver"
                                            placeholder={`${pool1 ? pool1 : "Select Symbol"}`}
                                            onChange={(value) => {
                                                //   setFromContractAddress(value.value);
                                                setPool1(value.label);
                                            }}
                                            value={pool1}
                                            options={allTokensPool2}
                                            isSearchable
                                        />
                                    </DropdownDiv>
                                </InputDiv>
                            </div>



                            <div className="col-12 col-md-3">
                                <label className="d-flex gap-1">Token to Get <span style={{
                                    fontSize: '8px'
                                }}>Token You Pay</span></label>

                                <InputDiv>
                                    <ChatSearchInput
                                        type="text"
                                        name="token"
                                        value={token}
                                        className="form-control mt-2"
                                        placeholder="Token to sell"
                                        onChange={handleChange}
                                    />
                                </InputDiv>
                            </div>

                            <div className=" flex flex-col col-12 col-md-3 ">
                                <label>Token to Sell Symbol</label>
                                <InputDiv>
                                    <DropdownDiv className="mb-0">
                                        <CustomSelect
                                            // isLoading={searchLoad}
                                            name="receiver"
                                            // onInputChange={handleInputChange}
                                            placeholder={`${pool2 ? pool2 : "Select Symbol"}`}
                                            onChange={(value) => {
                                                setPool2(value.label);
                                            }}
                                            value={pool2}
                                            options={dropdownOptions}
                                            isSearchable
                                        />
                                    </DropdownDiv>
                                </InputDiv>
                            </div>
                            <div className="col-12 col-md-3">
                                <label>Unlock Days</label>

                                <InputDiv>
                                    <ChatSearchInput
                                        type="number"
                                        name="unlockDay"
                                        value={unlockDay}
                                        className="form-control mt-2"
                                        placeholder="Enter Unlock Days"
                                        onChange={handleChange}
                                    />
                                </InputDiv>
                            </div>
                            <div className="col-12 col-md-3">
                                <label>Package to Sell</label>

                                <InputDiv>
                                    <ChatSearchInput
                                        type="number"
                                        name="packageToSell"
                                        value={packageToSell}
                                        className="form-control mt-2"
                                        placeholder="Enter Package to Sell"
                                        onChange={(e) => {
                                            e.target.value > 0 ? setPackageToSell(e.target.value) : setPackageToSell("")
                                        }}
                                    />
                                </InputDiv>
                            </div>

                            {/* <div className="col-12 col-md-3 ">
                                <label>Package Choice</label>

                                <InputDiv>
                                    <DropdownDiv className="mb-0">
                                        <CustomSelect
                                            name="packageChoice"
                                            placeholder={`Package Choice`}
                                            onChange={(value) => setPackageChoice(value.value)}
                                            value={packageChoice}
                                            options={packageChoiceOptions}
                                            isSearchable
                                        />
                                    </DropdownDiv>
                                </InputDiv>
                            </div> */}





                            <div className="col-12 col-md-3">
                                <label>Description</label>

                                <InputDiv>
                                    <ChatSearchInput
                                        type="text"
                                        name="description"
                                        value={description}
                                        className="form-control mt-2"
                                        placeholder="Enter Description"
                                        onChange={handleChange}
                                    />
                                </InputDiv>
                            </div>

                        </div>
                        {/* <div className="col-12 w-[100%] mt-4 justify-between">
                                {allTokens.map((item, idx) => {
                                    return (
                                        <div
                                            className="d-flex justify-between w-full items-center"
                                            key={idx}
                                        >
                                            <div className="flex gap-2">
                                                <input
                                                    type="checkbox"
                                                    className="shrink-0 mt-0.5 border-gray-200 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-gray-800 dark:border-gray-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
                                                    id={`hs-default-checkbox-${idx}`}
                                                    value={item.label}
                                                    onChange={(e) => handleSymbolChange(idx, e)}
                                                />
                                                <label
                                                    htmlFor={`hs-default-checkbox-${idx}`}
                                                    className="text-sm text-gray-500 ms-3 dark:text-gray-400"
                                                >
                                                    {item.label}
                                                </label>
                                            </div>


                                            {tokenData[idx]?.symbol && (
                                                <input
                                                    type="number"
                                                    className="ml-3 border-black-200 rounded text-blue-600 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-offset-gray-800"
                                                    placeholder="Enter price"
                                                    name="price"
                                                    onChange={(e) => handlePriceChange(idx, e)}
                                                />
                                            )}
                                        </div>
                                    );
                                })}
                            </div> */}
                        <div className="d-flex justify-content-center">
                            <FormButton
                                type="submit"
                                variant="contain-success"
                                className="py-2 mt-2 col-12 col-md-4"
                                onClick={CreateNewOtcMarketplacePackage}
                            >
                                Create New Package
                            </FormButton>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
};
export default CreateOtcGeneralPackage;
const InputDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  color: white;
  padding: 5px 0px;
  font-size: 14px;
`;
const DropdownDiv = styled.div`
  display: block;
  @media screen and (max-width: 876px) {
    width: 100%;
  }
`;
const FormButton = styled(Button)`
  color: "white";
  mergin-top: 1rem;
`;
const ChatSearchInput = styled.input`
  width: 100%;
  height: 100%;
  font-size: 12px;
  transition: all 0.3s;
  background: transparent;
  border: none;
  padding-left: 2px;
  border-bottom: 1px solid #b1b1b1;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  color: #b1b1b1;

  &:focus,
  &:active {
    outline: none;
    box-shadow: none;
    color: #b1b1b1;
    background: transparent;
    border-bottom: 2px solid #47c9a4;
  }

  &::-webkit-input-placeholder {
    color: #b1b1b1;
  }
  &::-moz-placeholder {
    color: #b1b1b1;
  }
  &:-moz-placeholder {
    color: #b1b1b1;
  }
  &:-ms-input-placeholder {
    color: #b1b1b1;
  }
`;
